<template>
    <div class="tab-main">
        <UserCard v-if="isMobile" class="tab-main-item"></UserCard>
        <Folder v-if="isMobile" class="no-header" title="" :expandable="false">
            <router-link :to="{ name: 'account-achievements' }" class="profile-block">
                <img
                    class="profile-block__image profile-block__image--awards"
                    src="@/assets/images/account/awards.svg"
                />
                Достижения
            </router-link>
        </Folder>
        <Folder v-if="isMobile" class="no-header" title="" :expandable="false">
            <router-link :to="{ name: 'account-reporting' }" class="profile-block">
                <img
                    class="profile-block__image profile-block__image--reporting"
                    src="@/assets/images/account/reporting.svg"
                />
                Персональные отчеты
            </router-link>
        </Folder>
        <!-- <Folder
            isFoldedDefault
            v-if="isMobile"
            class="folder competencies tab-main-item"
            title="Календарь активностей"
        >
            <Calendar />
        </Folder> -->
    </div>
</template>

<script>
import Folder from '@/components/UI/Folder';
//import Calendar from '@/components/calendar/Calendar';
import UserCard from '../userCard/UserCard';

import { mapGetters, mapActions } from 'vuex';

const getters = ['hasLeader', 'jobOffers', 'isMobile'];

const actions = ['getJobOffers'];

export default {
    name: 'TabMain',
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        ...mapActions(actions),
    },
    components: {
        Folder,
        UserCard,
        // Calendar,
    },
    created() {
        if (!this.isMobile) {
            this.$route.replace({ name: 'account-main' });
        }
        this.getJobOffers();
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
@import '~@/styles/variables';

.tab-main {
    width: 100%;

    .tab-main-item {
        @include on-mobile {
            margin-bottom: mrem(24);
            box-shadow: 0px 2px 8px rgba(155, 161, 166, 0.23626);
        }

        &:last-of-type {
            @include on-mobile {
                margin-bottom: 0;
            }
        }
    }
}

.folder {
    margin-top: 1rem;

    @include on-mobile {
        margin-top: 0;
    }

    :deep(.title) {
        font-family: Montserrat, sans-serif;
        font-size: mrem(16);
        font-style: normal;
        font-weight: 700;
        line-height: mrem(52);
        @include on-desktop {
            font-size: rem(16);
            line-height: rem(52);
        }
    }
}

.no-header {
    padding: 0;
    :deep(header) {
        display: none;
    }
    :deep(footer) {
        padding: 0 mrem(8);
        display: flex;
        align-items: center;
        height: mrem(72);

        .profile-block {
            font-family: Montserrat, sans-serif;
            font-size: mrem(16);
            font-style: normal;
            font-weight: 700;
            line-height: mrem(52);
            display: flex;
            align-items: center;
            gap: urem(12);
            
            @include on-desktop {
                font-size: rem(16);
                line-height: rem(52);
            }

            &__image {
                &--awards {
                    height: mrem(52);
                    @include on-desktop {
                        height: rem(52);
                    }
                }
                &--reporting {
                    height: mrem(44);
                    @include on-desktop {
                        height: rem(44);
                    }
                }
            }
        }
        @include on-desktop {
            padding: rem(20) rem(32);
            height: rem(90);
        }
    }
}
</style>
